// extracted by mini-css-extract-plugin
module.exports = {"container":"ReturnDetails_container__QuixD","paragraph":"ReturnDetails_paragraph__oY_TV","link":"ReturnDetails_link__dGU3P"};